// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.less'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import Notify from 'vue2-notify'
import Autocomplete from './components/lib/Autocomplete'
import Autocompletesimple from './components/lib/Autocompletesimple'
import Switch from './components/lib/Switch'
import InputValidation from './components/lib/InputValidation'
import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'
import moment from 'moment'
import ClickOutside from 'vue-click-outside'

Vue.use(Notify,
{
    position: 'top-right'
})
Vue.use(BootstrapVue);
Vue.use(VueI18n)

Vue.component('icon', Icon)
Vue.component('autocomplete', Autocomplete)
Vue.component('autocompletesimple', Autocompletesimple)
Vue.component('inputvalidation', InputValidation)
Vue.component('input-switch', Switch)
Vue.component('datepicker', Datepicker)
Vue.component('timepicker', VueTimepicker)

Vue.config.productionTip = false

const i18n = new VueI18n(
{});

Vue.directive('click-outside', ClickOutside);

Vue.directive('focus',
{
    // When the bound element is inserted into the DOM...
    inserted: function(el)
    {
        // Focus the element
        el.focus()
    }
})

Vue.mixin(
{
    methods:
    {
        back: function()
        {
            window.history.back();
        },
        formatDate: function(date, format = 'DD.MM.YYYY. HH:mm')
        {
            if(date == null) return '';
            return moment(date).format(format);
        },
        startChatByUserId(userId, workOrderId)
        {
            var me = this;
            this.$store.commit('setChatData',
            {
                chatUserId: userId,
                workOrderId: workOrderId
            })
        },
        startChatByUserIdDental(userId, dentalSolutionId)
        {
            var me = this;
            this.$store.commit('setChatData',
            {
                chatUserId: userId,
                dentalSolutionId: dentalSolutionId
            })
        },
    }
})

/* eslint-disable no-new */
new Vue(
{
    el: '#app',
    store: store,
    router,
    i18n,
    template: '<App/>',
    components:
    {
        App
    }
})


// WEBPACK FOOTER //
// ./src/main.js